export function isEdsV2Database(database: { data_pipeline?: string } | null | undefined): boolean {
    return database?.data_pipeline === 'edsv2';
}
